export default "__VITE_ASSET__Bocfi5ur__"